import Activity from '../interfaces/Activity'
import type ActivityContact from '../interfaces/ActivityContact'
import { ActivityState } from './types'
import ActivityTasks from '../interfaces/ActivityTasks'
import { GetterTree } from 'vuex'
import { RootState } from '@/Common/store/types'
import Task from '../../Task/interfaces/Task'

export const getters: GetterTree<ActivityState, RootState> = {
  activities(state): Activity[] | null {
    return state.activities
  },
  activityContacts(state): ActivityContact[] | null {
    return state.activityContacts
  },
  activityTasks(state): ActivityTasks[] | null {
    return state.activityTasks
  },
  selectedActivity(state): ActivityContact | null {
    return (
      state.activityContacts?.find((ac) => {
        return ac.contacts.filter((c) => c.isSelected).length > 0
      }) || null
    )
  },
  selectedActivityTasks(state, getters): Task[] | null {
    if (getters.selectedActivity && state.activityTasks) {
      const at = state.activityTasks.find((at) => at.activity.id == getters.selectedActivity.activity.id)
      return at ? at.tasks : null
    }
    return null
  },
}
